import React from 'react';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
import { addEcommerceEventToDataLayer } from '../TrackingInformation';
import ProductLink from 'Shared/ProductComponents/ProductLink';
export default class RecipeItem extends React.Component {
    constructor(props) {
        super(props);
        this.onClickItem = (trackingData, url) => {
            if (!!trackingData) {
                var viewItemListEvents = trackingData.ga4EventObjects['select_item'];
                if (!!viewItemListEvents && !!this.props.product && !!this.props.product.variants) {
                    var selectedvariant = this.props.product.variants[0];
                    var event = viewItemListEvents[selectedvariant.code];
                    if (!!event) {
                        addEcommerceEventToDataLayer(event);
                    }
                }
            }
        };
    }
    render() {
        return (React.createElement("tr", null,
            React.createElement("td", null,
                !!this.props.amount && this.props.amount,
                " ",
                !!this.props.amount && !!this.props.unit && this.props.unit.name),
            React.createElement("td", null,
                !!this.props.product ? (React.createElement("span", { onClick: () => this.onClickItem(this.props.trackingData, this.props.product.url) },
                    React.createElement(ProductLink, { product: this.props.product, linkUrl: this.props.product.url, code: this.props.product.code, ticket: this.props.product.ticket, title: epiPropertyValue(this.props.product.content.code) }, epiPropertyValue(this.props.product.content.displayName)))) : (this.props.name),
                !!this.props.noNutritions && '* ',
                !!this.props.notSold && '**')));
    }
}
